<template>
  <div class="tasks">
    <ag-table
      :data-source-api="getAllTasks"
      :grid-options="gridOptions"
      :permissions="permissions"
      :rtl="false"
      :is-entities-response="false"
      @emitAddNewRecord="() => {
        $router.push({ path: '/volunteers/tasks/add' });
      }"
    />
  </div>
</template>

<script>
import { RepositoryFactory } from "../volunteer-repositories/volunteerRepositoryFactory";
import AgTable from "../../shared/shared-components/ag-grid/AgTableServerSide.vue";
import AgTableBtnCell from "../../shared/shared-components/ag-grid/AgTableBtnCell";
import AgButton from "@/app/shared/shared-components/ag-grid/AgButton";
import utilities from "@/app/shared/utilities/index";

const tasksRepo = RepositoryFactory.get("tasksRepository");

export default {
  name: "TasksManagement",
  components: {
    AgTable,
    // eslint-disable-next-line vue/no-unused-components
    AgButton,
    // eslint-disable-next-line vue/no-unused-components
    AgTableBtnCell,
  },
  data() {
    return {
      gridApi: null,
      gridOptions: null,
      status: {
        pending: "قيد الانتظار",
        in_progress: "قيد التنفيذ",
        completed: "تم التنفيذ",
      },
      taskTypes: {
        normal: "عادي",
        urgent: "مستعجل",
      },
      permissions: {
        add: "tasks_management",
        edit: "tasks_management",
        delete: "tasks_management",
        "view-users": "volunteer_manage",
      },
    };
  },
  methods: {
    createColDefs() {
      let self = this;
      return [
        {
          headerName: "معرف الفرصة",
          field: "id",
          sortable: true,
          width: 200,
        },
        {
          headerName: "مجال الفرصة",
          field: "volunteeringField.name",
          filter: "agTextColumnFilter",
          sortable: true,
          width: 200,
        },
        {
          headerName: "العنوان",
          field: "title",
          filter: "agTextColumnFilter",
          width: 210,
          sortable: false,
        },
        {
          headerName: "الوصف",
          field: "description",
          filter: "agTextColumnFilter",
          width: 210,
          sortable: false,
        },
        {
          headerName: "من تاريخ",
          field: "startAt",
          filter: "agDateColumnFilter",
          width: 200,
          sortable: false,
          valueGetter: function getObject(data) {
            return data.data.startAt ? utilities.formatDate(data.data.startAt, "yyyy-MM-DD") : '-';
          },
        },
        {
          headerName: "إلى تاريخ",
          field: "endAt",
          filter: "agDateColumnFilter",
          width: 200,
          sortable: false,
          valueGetter: function getObject(data) {
            return data.data.endAt ? utilities.formatDate(data.data.endAt, "yyyy-MM-DD") : '-';
          },
        },
        {
          headerName: "الحالة",
          field: "status",
          width: 210,
          sortable: false,
          valueGetter: function getObject(params) {
            return self.status[params.data.status] || "-";
          },
          filter: "agSetColumnFilter",
          filterParams: {
            values: Object.keys(self.status),
            valueFormatter: (params) =>
              self.status[params.value] || params.value,
          },
        },
        {
          headerName: "النوع",
          field: "type",
          width: 210,
          sortable: false,
          valueGetter: function getObject(params) {
            return self.taskTypes[params.data.type] || "-";
          },
          filter: "agSetColumnFilter",
          filterParams: {
            values: Object.keys(self.taskTypes),
            valueFormatter: (params) =>
              self.taskTypes[params.value] || params.value,
          },
        },
        {
          headerName: "المواصفات",
          field: "specifications",
          width: 210,
          sortable: false,
        },
        {
          headerName: "الخطوات",
          field: "steps",
          width: 210,
          sortable: false,
        },
        {
          headerName: "عدد النقاط",
          field: "couponPoints",
          width: 210,
          sortable: false,
        },
        {
          headerName: "المتطوعين",
          field: "volunteeringFieldId",
          width: 210,
          sortable: false,
          cellRendererFramework: AgButton,
          valueGetter: function getObject(params) {
            return params.data.id;
          },
          cellRendererParams: (params) => {
            return {
              size: "small",
              color: "primary",
              name: "إسناد المتطوعين",
              type: "gradient",
              disabled: !["pending"].includes(params.data.status),
              click(taskId) {
                self.$router.push({
                  path: `/volunteers/tasks/${taskId}/assign`,
                });
              },
            };
          },
        },
        {
          headerName: "يمكن إرفاق ملف؟",
          field: "canUploadAttachment",
          width: 210,
          sortable: true,
          valueGetter: function getObject(params) {
            return params.data.canUploadAttachment
              ? "نعم"
              : "لا";
          },
        },
        {
          headerName: "الإجراءات",
          cellRendererFramework: AgTableBtnCell,
          sortable: false,
          valueGetter: function getObject(params) {
            return params.data;
          },
          cellRendererParams: {
            editRecord: function (task) {
              self.$router.push({
                path: `/volunteers/tasks/${task.id}/edit`,
              });
            },
            viewRecordDetails: function (task) {
              self.$router.push({
                path: `/volunteers/tasks/${task.id}/sessions`,
              });
            },
            deleteRecord: function (task) {
              self.onRemoveTask(task);
            },
            repeatRecord: function (task) {
              self.onRepeatTask(task);
            },
            viewUsersRecord: function (task) {
              self.$router.push({
                path: `/volunteers/tasks/${task.id}/volunteers`,
              });
            },
            actions: ["edit", "view" , "delete", "repeat", "view-users"],
            confirmRepeat: false,
            permissions: self.permissions,
          },
        },
      ];
    },
    async onCompleteTask(taskId) {
      await tasksRepo.completeTask(taskId);
      await this.gridApi.refreshServerSideStore({ purge: true });
    },
    async onRemoveTask(task) {
      await tasksRepo.removeTask(task.id);
      await this.gridApi.refreshServerSideStore({ purge: true });
    },
    onRepeatTask(task) {
      this.$router.push({
        path: `/volunteers/tasks/${task.id}/duplicate`,
      });
    },
    async getAllTasks(query) {
      return await tasksRepo.fetchTasks(`${query}&filter=status||$notin||completed&sort=createdAt,DESC`);
    },
  },
  created() {
    this.gridOptions = {};
    this.gridOptions.columnDefs = this.createColDefs();
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
  },
};
</script>
